// @flow
import TraceLogger from 'app/packages/trace-logger/TraceLogger';

const traceLogger = new TraceLogger();

export default traceLogger;
